<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="filters.search"
        outlined
        :label="$t('DATA_TABLE.SEARCH')"
        append-icon="mdi-magnify"
        @input="refreshData"
      />
    </v-col>
  </v-row>
</template>

<script>
import { yearFormat, dateFormatBackend } from '@/modules/_global/filters';
import { isEqual } from 'lodash';

export default {
  name: 'DocumentsListsListFilter',

  filters: {
    yearFormat,
    dateFormatBackend
  },

  components: {},

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      filters: {}
    };
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  methods: {
    valueWatchHandler(formProps) {
      if (isEqual(formProps, this.filters)) {
        return;
      }

      this.filters = {
        ...this.filters,
        ...formProps
      };
    },

    refreshData() {
      this.$emit('setRequest', { ...this.filters });
    }
  }
};
</script>
